import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { Modal } from "../../theme/Component/Modal";
import { BasicTable } from "../../theme/Component/BasicTable";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { SelectorDocumentFactory } from "./SelectorDocumentFactory";
import { BasicButton } from "../../theme/Component/BasicButton";
import { PrintJson } from "../../theme/Component/PrintJson";
import { ListMenu } from "../../theme/Component/ListMenu";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal";

interface conf {
    label?: string;
}

interface Props {
    year?: number;
    nemonic?: string;
    onChange: Function;
    configProps?: conf;
}

export const EditorBodegaDocumentos = ({ year, nemonic, onChange, configProps }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_DocumentFactory);

    const [form, setForm] = useState<any>({
        Year: year ?? _single.getCurrenYear(),
    });

    const modalDoc = useModal("DOcumento", MODAL_XL);

    useEffect(() => {
        if (nemonic)
            setForm({ ...form, Mnemonic: nemonic ?? "" })
    }, [nemonic])

    const [valor, setValor] = useState<string>("")
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const buscarDocumento = () => {
        instance.getDocumentsAndConsecutive(form.Year, form.Mnemonic, form.Consecutive ?? null, null, null, null, form.Reference ?? null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => toast.error(err));
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: false },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Externo', property: 'ExternalReference', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },
        { title: 'Estado del Documento', property: 'DocumentStateName', visible: true },
    ]

    const validateData = () => {
        if (form.Year && form.Mnemonic && (form.Consecutive || form.Reference)) {
            buscarDocumento();
        } else {
            toast.error("Los campos Año, Tipo y Consecutivo o Consecutivo Externo son Obligatorios");
        }
    }

    const getItem = () => {
        if (bean.IDDocument) {
            onChange?.(bean);
            setValor(`${bean.Mnemonic} - ${bean.Consecutive}`);
            setModal({ ...modal, view: false });
        } else {
            toast.error("Documento no valido")
        }
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: true, evento: () => { getPdfAccountantDocument() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [documentos, setDocuementos] = useState<any>([]);

    const getPdfAccountantDocument = () => {
        instance.getPdfAccountantDocument(bean.IDDocument, bean.Mnemonic, bean.Since, _single.getAccountID()).then(
            (resp: any) => {
                modalDoc.open();
                setDocuementos(resp.DocumentURL);
            }
        ).catch(err => toast.error(err));
    }

    return (
        <>

            <label>{configProps?.label ?? "Documento"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Obligaciones Presupuestales del tercero" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <div className="row">
                        <div className="col-md-6">
                            <YearSelector value={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                        </div>
                        {nemonic ? (
                            <div className="col-md-6">
                                <label>Tipo de Documento</label>
                                <input disabled type="text" value={nemonic} className="form-control" />
                            </div>
                        ) : (
                            <div className="col-md-6">
                                <SelectorDocumentFactory label="Tipo de Documento" onChange={(e) => { setForm({ ...form, "Mnemonic": e.Mnemonic }) }} />
                            </div>
                        )}
                        <div className="col-md-6">
                            <label>Consecutivo</label>
                            <input type="number" name="consecutivo" className="form-control" value={form.Consecutive} onChange={(e) => { setForm({ ...form, "Consecutive": parseInt(e.target.value) }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Consecutivo Externo</label>
                            <input type="number" name="consecutivoExt" className="form-control" value={form.Reference} onChange={(e) => { setForm({ ...form, "Reference": parseInt(e.target.value) }) }} />
                        </div>
                        <div className="col-md-6 mt-4">
                            <BasicButton icon="ri-search-line" eventClick={validateData}>Buscar</BasicButton>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                            <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal}>
                                <div className="row">
                                    <div className="col">
                                        <DocumentViewer list={documentos} IDDocument={bean.IDDocument} Since={bean.Since} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}